import React, { createContext, useContext, useState, useCallback } from "react";

const UIContext = createContext(null);

export const useUI = () => useContext(UIContext);

export const UIProvider = ({ children }) => {
  const [uploadOpen, setUploadOpen] = useState(false);
  const [leadOpen, setLeadOpen] = useState(false);
  const [leadConfig, setLeadConfig] = useState({ type: "beratung", topic: "" });

  const openUpload = useCallback(() => setUploadOpen(true), []);
  const openLead = useCallback((config = {}) => {
    setLeadConfig({ type: config.type || "beratung", topic: config.topic || "" });
    setLeadOpen(true);
  }, []);

  return (
    <UIContext.Provider
      value={{ uploadOpen, setUploadOpen, leadOpen, setLeadOpen, leadConfig, openUpload, openLead }}
    >
      {children}
    </UIContext.Provider>
  );
};
